import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalProvider } from './GlobalContext';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Chat from './pages/Chat';
import ItineraryListview from './pages/ItineraryListview';
import ItineraryMapview from './pages/ItineraryMapview';
import useViewportHeight from './hooks/useViewportHeight';

const App = () => {
  useViewportHeight();

  return (
    <div style={{ height: 'calc(var(--vh, 1vh) * 100)' }}>
      <GlobalProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/itinerary/listview" element={<ItineraryListview />} />
            <Route path="/itinerary/mapview" element={<ItineraryMapview />} />
          </Routes>
        </Router>
      </GlobalProvider>
    </div>
  );
};

export default App;
